module.exports = __webpack_public_path__ + "img/icon-tire.ad2012cd.svg";